var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcCreditCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10563",
    "data-name": "Group 10563",
    transform: "translate(-1065 -1496)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17830",
    "data-name": "Rectangle 17830",
    width: 40,
    height: 40,
    transform: "translate(1065 1496)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-money-check",
    "data-name": "Icon awesome-money-check",
    d: "M0,27.6a1.95,1.95,0,0,0,1.95,1.95h35.1A1.95,1.95,0,0,0,39,27.6V8.1H0ZM27.3,14.925a.975.975,0,0,1,.975-.975h5.85a.975.975,0,0,1,.975.975v1.95a.975.975,0,0,1-.975.975h-5.85a.975.975,0,0,1-.975-.975Zm0,7.312a.487.487,0,0,1,.488-.487h6.825a.487.487,0,0,1,.487.487v.975a.487.487,0,0,1-.487.487H27.788a.487.487,0,0,1-.488-.487ZM3.9,16.387a.487.487,0,0,1,.487-.487H22.913a.487.487,0,0,1,.487.487v.975a.487.487,0,0,1-.487.488H4.387a.487.487,0,0,1-.487-.488Zm0,5.85a.487.487,0,0,1,.487-.487H15.113a.487.487,0,0,1,.488.487v.975a.487.487,0,0,1-.488.487H4.387a.487.487,0,0,1-.487-.487ZM38.025,2.25H.975A.975.975,0,0,0,0,3.225V6.15H39V3.225A.975.975,0,0,0,38.025,2.25Z",
    transform: "translate(1065.5 1500.35)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCreditCard);
export default __webpack_public_path__ + "static/media/ic_credit_card.20f5aa4682923e4df90400e4930baddb.svg";
export { ForwardRef as ReactComponent };